import CloudIcon from '@mui/icons-material/Cloud';
import { blue } from '@mui/material/colors';
import Paper from '@mui/material/Paper';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useScope, useUser } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';

const linkStyle = {
  fontSize: '18px',
  borderRadius: '4px',
  padding: '5px 8px',
  border: `2px solid ${blue[500]}`,
  marginBottom: '8px',
};

function SiteGroupSupportPage(props) {
  const { location } = props;

  const { t } = useTranslation();
  const { isStaff } = useUser();
  const { customer, siteGroup } = useScope();

  const isBillboard = customer?.is_billboard ?? true;
  const isVirtual = siteGroup?.is_virtual ?? false;

  const pageTitle = (
    <span>
      {t('siteGroups.siteGroup')} {t('general.support')} - {isVirtual && <CloudIcon title={t('general.virtual')} />}{' '}
      {siteGroup?.name ?? ''}. {siteGroup?.description ?? ''}
    </span>
  );

  const supportPath = location.pathname;
  const rmaPath = supportPath + '/rmas';
  const ticketPath = supportPath + '/tickets';

  return (
    <AppNav page="plant" notFullHeight={true} {...props}>
      <div className="container-fluid " style={{ top: '64px', height: '100%', margin: '0 16px' }}>
        <TitleBar showBackButton title={pageTitle} />
        <div className="row" style={{ height: 'calc(100% - 64px)' }}>
          <div className="col-lg-6" style={{ marginBottom: '16px' }}>
            <Paper
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'var(--surface-primary)',
                padding: '16px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <h3 style={{ color: 'var(--text-secondary)' }}>{t('support.returns')}</h3>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <div>{t('support.needToLookUpReturn')}</div>
                <div>
                  {t('support.clickToViewReturns', {
                    type: isBillboard ? t('siteGroups.plant').toLowerCase() : t('siteGroups.siteGroup').toLowerCase(),
                  })}
                </div>
              </div>
              <div style={{ marginTop: '12px' }}>
                <Link to={rmaPath} style={linkStyle}>
                  {t('support.viewReturns')}
                </Link>
              </div>
            </Paper>
          </div>

          <div className="col-lg-6" style={{ marginBottom: '16px' }}>
            <Paper
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'var(--surface-primary)',
                padding: '16px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <h3 style={{ textAlign: 'center', color: 'var(--text-secondary)' }}>{t('support.supportTickets')}</h3>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <div>{t('support.lookingForTicket')}</div>
                <div>
                  {t('support.clickToViewTickets', {
                    type: isBillboard ? t('siteGroups.plant').toLowerCase() : t('siteGroups.siteGroup').toLowerCase(),
                  })}
                </div>
              </div>
              <div style={{ marginTop: '12px' }}>
                <Link to={ticketPath} style={linkStyle}>
                  {t('support.viewTickets')}
                </Link>
              </div>
            </Paper>
          </div>
          <div className="col-sm-12" style={{ marginBottom: '16px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                color: 'var(--text-secondary)',
                paddingTop: '4px',
              }}
            >
              <div>{t('support.needHelp')}</div>
              <div>
                {t('support.email')}: <a href="mailto:support@outdoorlinkinc.com">support@outdoorlinkinc.com </a>
              </div>
              <div>
                {t('support.phone')}: <a href="tel:+12568859768">+1 (256) 885-9768 </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppNav>
  );
}

export default SiteGroupSupportPage;
